import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { GlobalFilterComponent } from 'components/common/GlobalFilterComponent/GlobalFilterComponent';
import { ActivityCodesFilter } from 'components/common/GlobalFilterComponent/components/ActivityCodesFilter/ActivityCodesFilter';
import { MilestoneFragnetFilter } from 'components/common/GlobalFilterComponent/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { TagsFilter } from 'components/common/GlobalFilterComponent/components/TagsFilter/TagsFilter';
import { WbsFilter } from 'components/common/GlobalFilterComponent/components/WbsFilter/wbsFilter';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';

import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { TreeProgramTopHeader } from 'components/common';
import { Trends } from 'components/widgets/Trends/Trends';

export const TrendsPage = () => {
    useFullStoryPageView({ pageName: executionConfig.crossVersionsAnalysis.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader>
                            <ShareInsightButton
                                title={executionConfig.crossVersionsAnalysis.title}
                                link={window.location.href}
                            />
                            <GlobalFilterButton />
                        </TreeProgramTopHeader>
                    </VersionSection>
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={executionConfig.crossVersionsAnalysis.title} />
                    <GlobalFilterComponent
                        defaultValues={{ milestoneFragnet: null, tags: [], activityCodes: [], wbs: null }}
                    >
                        <MilestoneFragnetFilter name={'milestoneFragnet'} />
                        <TagsFilter name={'tags'} />
                        <ActivityCodesFilter name={'activityCodes'} />
                        <WbsFilter name={'wbs'} />
                    </GlobalFilterComponent>
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <PageWidgetWrapper>
                    <Trends />
                </PageWidgetWrapper>
            </MainContent>
        </PageContainer>
    );
};
